module.exports = __webpack_public_path__ + "static/media/public_bg.6bedfece.png";